import { useLemonadeContext } from "@/LemonadeProvider";
import { useForm } from "react-hook-form";
import "../styles/NewLemonadeForm.css";
import { useEffect } from "react";

type SaleForm = {
    lemonade: string;
    amount: number;
    price: number;
};

export function NewSaleForm() {
    const { lemonades, addSale } = useLemonadeContext();
    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
        formState: { errors }
    } = useForm<SaleForm>({ shouldFocusError: false });

    const selectedLemonade = watch("lemonade");
    const amount = watch("amount");

    // auto-calculate price when lemonade or amount changes
    useEffect(() => {
        const lemonadeObj = lemonades.find((l) => l.name === selectedLemonade);
        let price = 0;
        if (lemonadeObj && amount && !isNaN(amount)) {
            price = Math.round(lemonadeObj.price * amount * 0.1);
        }
        setValue("price", price);
    }, [selectedLemonade, amount, lemonades, setValue]);

    const onSubmit = async (data: SaleForm) => {
        const lemonadeObj = lemonades.find((l) => l.name === data.lemonade);
        if (!lemonadeObj) {
            alert("Nincs ilyen limonádé.");
            return;
        }
        const result = await addSale({
            lemonade: lemonadeObj,
            amount: data.amount,
            price: data.price,
            date: new Date()
        });
        if (typeof result === "string") {
            alert(result);
        } else {
            alert("Eladás rögzítve!");
            reset();
        }
    };

    const lemonadeObj = lemonades.find((l) => l.name === selectedLemonade);
    let price = 0;
    if (lemonadeObj && amount && !isNaN(amount)) {
        price = Math.round(lemonadeObj.price * amount * 0.1);
    }
    const formattedPrice = price.toLocaleString("hu-HU", { style: "currency", currency: "HUF", maximumFractionDigits: 0 });

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="lemonade-form">
            <h1 className="main-title">Új eladás</h1>
            <select
                {...register("lemonade", {
                    required: "Válassz limonádét!",
                    validate: (value) => lemonades.find((l) => l.name === value) != null || "Érvénytelen limonádé"
                })}
                defaultValue=""
            >
                <option value="" disabled>
                    Válassz limonádét
                </option>
                {lemonades.map((l) => (
                    <option key={l.name} value={l.name}>
                        {l.name}
                    </option>
                ))}
            </select>
            {errors.lemonade && <span className="error-message">{errors.lemonade.message}</span>}

            <input
                type="number"
                step="0.1"
                min="1"
                {...register("amount", {
                    required: "A mennyiség kötelező",
                    valueAsNumber: true,
                    min: { value: 1, message: "Legalább 1 dl" }
                })}
                placeholder="Mennyiség dl-ben"
            />
            {errors.amount && <span className="error-message">{errors.amount.message}</span>}

            <div className="calculated-price">Összeg: {formattedPrice}</div>

            <div className="submit-row">
                <button type="submit">Eladás rögzítése</button>
            </div>
        </form>
    );
}
